// extracted by mini-css-extract-plugin
module.exports = {"sagLogo":"_fb07fd5","sitAndGoLogo":"_65e705f","label":"_278ba25","finalStep":"_037bff6"};